// "2026-09-20" in the viewer's OWN clock, not UTC - Daily's day boundary is deliberately
// local time (Martin, 2026-09-2x brainstorm: "we can use the get your local time definition
// of what today is"), unlike the rest of this admin (Matches/Match Events display everything
// in UTC). getFullYear/getMonth/getDate below are the local-time accessors on purpose - the
// UTC ones would silently shift the boundary by the viewer's own offset.
export function todayLocalDateString() {
  const now = new Date();
  return toDateParam(now);
}

export function toDateParam(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function isValidDateParam(value) {
  return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value);
}
